//export const API_URL = 'http://127.0.0.1:8000/api';
//export const API_URL = 'http://192.168.110.60:8000/api';

 

export const API_URL ='https://api-casamento.milvendas.ao/api';
